import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

function csrfToken(): string {
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? '';
}

/**
 * Lazily create the shared Laravel Echo (Reverb) client. Idempotent — the first
 * caller (planning room, waiting page, or the global team-notification listener)
 * wins and the single `window.Echo` is reused everywhere.
 */
export function ensureEcho(): void {
    if (window.Echo) {
        return;
    }

    const portRaw = import.meta.env.VITE_REVERB_PORT;
    const port = portRaw ? Number(portRaw) : undefined;

    window.Pusher = Pusher;
    window.Echo = new Echo({
        broadcaster: 'reverb',
        key: import.meta.env.VITE_REVERB_APP_KEY,
        wsHost: import.meta.env.VITE_REVERB_HOST,
        wsPort: port ?? 80,
        wssPort: port ?? 443,
        forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
        enabledTransports: ['ws', 'wss'],
        authEndpoint: '/broadcasting/auth',
        auth: {
            headers: {
                'X-CSRF-TOKEN': csrfToken(),
            },
        },
    });
}
